export default __webpack_public_path__ + "static/media/clock.985b71af.png";